import { useState } from 'react';
import { FormControl, FormHelperText, TextField } from '@mui/material';

interface TxtTelefoneProps {
  value: string;
  onChange: (value: string) => void; // envia valor limpo (só números)
  required?: boolean;
  label?: string;
  name?: string;
  disabled?: boolean;
}

export const TxtTelefone = ({ value, onChange, required = false, label = 'Telefone', name = 'telefone', disabled = false }: TxtTelefoneProps) => {
  const [error, setError] = useState<string>('');

  // Remove tudo que não for número
  const onlyNumbers = (val: string) => val.replace(/\D/g, '');

  // Aplica máscara dinâmica
  const maskTelefone = (val: string) => {
    const v = val.replace(/\D/g, ''); // só números
    if (!v) return ''; // se estiver vazio, retorna vazio

    if (v.length <= 10) {
      // Telefone fixo: (00) 0000-0000
      return v.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      // Celular: (00) 00000-0000
      return v.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
    }
  };

  // Validação simples
  const validateTelefone = (val: string) => {
    const v = onlyNumbers(val);
    if (v.length >= 10 && v.length <= 11) {
      setError('');
      return true;
    } else {
      setError('Telefone inválido (10 ou 11 dígitos)');
      return false;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = onlyNumbers(e.target.value);
    onChange(rawValue); // envia valor limpo
    validateTelefone(rawValue);
  };

  return (
    <FormControl fullWidth>
      <TextField
        required={required}
        label={label}
        disabled={disabled}
        name={name}
        value={maskTelefone(value)}
        onChange={handleChange}
        size="small"
        inputProps={{ maxLength: 15, inputMode: 'numeric' }}
        error={!!error}
      />
      <FormHelperText>{error || `${value.length} caracteres`}</FormHelperText>
    </FormControl>
  );
};
